import type {
  GuidedEditUpdateBudget,
  LaunchCampaignBudgetWire,
} from "@common/interfaces/adsManagerGuidedEdit";
import { readBudgetMinorAmount } from "@common/utils/campaignBudgetMeta";

/** {@link LaunchCampaignBudgetWire} for `type: "scheduled"` (minor amounts per segment). */
export function launchCampaignBudgetWireFromScheduledWired(
  wired: GuidedEditUpdateBudget & {
    type: "scheduled";
    segments: NonNullable<GuidedEditUpdateBudget["segments"]>;
  }
): LaunchCampaignBudgetWire {
  return {
    type: "scheduled",
    segments: wired.segments.map((s) => {
      const minor = readBudgetMinorAmount(s.amount as never);
      const cur =
        typeof s.amount === "object" && s.amount && "currency" in s.amount
          ? String((s.amount as { currency?: string }).currency ?? "USD")
          : "USD";
      return {
        time_start: s.time_start,
        time_end: s.time_end,
        amount: minor,
        currency: cur,
      };
    }),
  };
}

/** {@link LaunchCampaignBudgetWire} for daily / lifetime (flat `amount` in minor units). */
export function launchCampaignBudgetWireFromSimpleWired(
  wired: GuidedEditUpdateBudget
): LaunchCampaignBudgetWire {
  const type = wired.type === "daily" ? "daily" : "lifetime";
  const amount = wired.amount?.amount ?? 0;
  return {
    type,
    amount,
    ...(type === "lifetime" ? { lifetime: amount } : {}),
  };
}

/**
 * Turn a {@link GuidedEditUpdateBudget} from {@link wireGuidedEditBudgetFromFormDollars}
 * into POST `/ads/campaigns/launch` `budget` body.
 */
export function guidedEditWiredBudgetToLaunchCampaignWire(
  wired: GuidedEditUpdateBudget
): LaunchCampaignBudgetWire {
  if (
    wired.type === "scheduled" &&
    Array.isArray(wired.segments) &&
    wired.segments.length > 0
  ) {
    return launchCampaignBudgetWireFromScheduledWired(
      wired as GuidedEditUpdateBudget & {
        type: "scheduled";
        segments: NonNullable<GuidedEditUpdateBudget["segments"]>;
      }
    );
  }
  return launchCampaignBudgetWireFromSimpleWired(wired);
}
